import { Chip, Stack, Typography } from '@mui/material';

import { TableCellCustom, TruncatedTypography } from '@app/components';
import { IETARowState } from '../types';
import { ETAStatus } from '@app/constants';

interface Props {
  row: IETARowState;
  selected: boolean;
  onSelectRow: VoidFunction;
}

const EtaRow = (props: Props) => {
  const { row } = props;

  return (
    <>
      <TableCellCustom flex style={{ cursor: 'pointer' }}>
        <Typography variant="body2" textAlign={'center'} minWidth={100} maxWidth={200}>
          {row?.taskName ?? 'N/A'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom flex style={{ cursor: 'pointer' }}>
        <Stack sx={{ alignItems: 'center' }}>
          <TruncatedTypography
            text={row?.description ?? 'N/A'}
            isHtml
            lines={10}
            height={80}
            component="div"
            variant="body2"
          />
        </Stack>
      </TableCellCustom>
      <TableCellCustom flex style={{ cursor: 'pointer' }}>
        <Stack sx={{ alignItems: 'center' }}>
          <Typography variant="body2">{row?.expectedEta ?? 'N/A'}</Typography>
        </Stack>
      </TableCellCustom>
      <TableCellCustom flex style={{ cursor: 'pointer' }}>
        <Typography variant="body2" textAlign={'center'}>
          {row?.actualEta ?? 'N/A'}
        </Typography>
      </TableCellCustom>
      <TableCellCustom align="center" sx={{ width: 130 }}>
        <Chip
          label={row?.status}
          color={row?.status === ETAStatus.completed ? 'success' : 'warning'}
          variant="soft"
          sx={{
            fontWeight: 500,
            minWidth: 90,
            borderRadius: 1,
          }}
        />
      </TableCellCustom>
    </>
  );
};

export { EtaRow };
